import { SubmitButtonConfig, SubmitButton } from 'ui/components/SubmitButton'
import { locationsApi } from 'api'
import { SUCCESS_LOCATION_UPDATE } from 'texts/locationDetails'
import { URLS } from 'constants/urls'
import { pendingLocationsCountSelector } from 'redux/locations/selectors'
import { LOCATION_DETAILS_FORM_ID } from 'modules/Locations/constants'

const locationsConfig: SubmitButtonConfig = {
  formId: LOCATION_DETAILS_FORM_ID,
  pendingCountSelector: pendingLocationsCountSelector,
  completeApiRequest: (companyId) =>
    locationsApi.hirePointComplete(String(companyId)),
  successMessage: SUCCESS_LOCATION_UPDATE,
  pageStatusKey: 'locationsStatus',
  navigateUrl: `${URLS.LOCATIONS}${URLS.LIST_OF_LOCATIONS}`,
  textKey: 'LOCATIONS',
}

export const LocationsSubmitButton = () => (
  <SubmitButton config={locationsConfig} />
)
